import React from 'react';
import injectSheet from "react-jss";
import { globalTheme } from "../../styles/globalTheme";

const DeltagareRad = ({
  classes,
  className,
  buttons,
  activeChoice,
  height = "auto",
  legend,
}) => {
  if (!buttons) return null;
  return (
    <div className={`${classes.buttonBar}${className ? ` ${className}` : ""}`}>
      <fieldset>
        <legend>{legend}</legend>
        {buttons.map(([buttonName, buttonContent, buttonOnClick], idx) => (
          <button style={{ height: height }} className={activeChoice === idx ? "active" : null} key={buttonName} onClick={() => { buttonOnClick(); }}>
            {buttonContent}
          </button>
        ))}
      </fieldset>
    </div>
  );
}

const BORDER_RADIUS = "5px";
const styles = (theme) => ({
  buttonBar: {
    position: "relative",
    display: "inline-block",

    cursor: "pointer",

    "& fieldset": {
      border: "none",
      "& legend": {
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "1px",
        color: globalTheme.colors.darkGray,
      },
    },

    textAlign: "center",
    "& button": {
      boxSizing: "border-box",
      backgroundColor: globalTheme.colors.white,
      color: theme.menuDarkColor,
      border: "2px solid " + theme.menuDarkColor,
      padding: "5px 10px",

      fontSize: "1.2em",

      position: "relative",
      zIndex: 0,
      "&:hover": {
        borderColor: theme.actionButtonColor,
        zIndex: 1,
      },
      "&.active": {
        backgroundColor: theme.menuDarkColor,
        color: globalTheme.colors.white,
        "&:hover": {
          backgroundColor: theme.actionButtonColor,
        },
      },
      "&:not(.active):hover": {
        color: theme.actionButtonColor,
      },
      "&:not(:first-of-type)": {
        // borderLeft: "none",
        marginLeft: "-2px",
      },
      "&:first-of-type": {
        borderTopLeftRadius: BORDER_RADIUS,
        borderBottomLeftRadius: BORDER_RADIUS,
      },
      "&:last-of-type": {
        borderTopRightRadius: BORDER_RADIUS,
        borderBottomRightRadius: BORDER_RADIUS,
      },
    }
  },
  "@media (max-width: 400px)": {
  },
});

export default injectSheet(styles)(DeltagareRad);